import {
  Box,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import Map from '../../components/Map/Map';
import { useMemo, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { debounce } from 'lodash';

const MapPage = () => {
  const [dateRange, setDateRange] = useState(7);
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');

  const handleChange = (event) => {
    setDateRange(event.target.value);
  };

  const debouncedSetSearchQuery = useMemo(
    () =>
      debounce((value) => {
        setDebouncedSearchQuery(value.trim());
      }, 1000),
    []
  );

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    debouncedSetSearchQuery(e.target.value);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setDebouncedSearchQuery('');
  };
  return (
    <Box
      sx={{
        marginTop: '1rem',
      }}
    >
      <Card className="shadow p-3 mt-4" sx={{ height: 'calc(100vh - 80px)' }}>
        <CardContent className="p-0 " sx={{ height: '100%' }}>
          <Typography
            variant="h5"
            className="mb-2 mb-3"
            sx={{ fontWeight: 700 }}
          >
            Incidents Map
          </Typography>

          <Grid container spacing={2} className="my-2">
            <Grid item xs={12} md={6}>
              <TextField
                color={'secondary'}
                label="Search incidents"
                placeholder="Search by incident number, type, or location..."
                size="small"
                value={searchQuery}
                onChange={handleSearchChange}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchQuery.length > 0 ? (
                        <ClearIcon
                          onClick={clearSearch}
                          sx={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <SearchIcon />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} className="d-flex justify-content-end">
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <Select
                  id="Period-selection"
                  value={dateRange}
                  onChange={handleChange}
                >
                  <MenuItem value={7}>Last 7 days</MenuItem>
                  <MenuItem value={30}>Last 30 days</MenuItem>
                  <MenuItem value={365}>Last year</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Map dateRange={dateRange} searchQuery={debouncedSearchQuery} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default MapPage;
